import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import moment from 'moment'
import _ from 'lodash'
import {
  Feed,
  Header,
  Icon,
  Loader,
  Message,
  Popup,
  Segment,
} from 'semantic-ui-react'

import { changeNotificationStatus } from '_actions/notifications'
import _t from 'utils/i18n_helper'
import { mydWWWOauthUrl } from 'config'

import './notifications.css'


const _ListNotifications = props => {
  const { className, notifications, loading } = props

  if (_.isEmpty(notifications) && ! loading) {
    return (
      <Message warning>
        <Message.Header>{ _t('NO_NOTIFICATIONS_TO_SHOW') }</Message.Header>
      </Message>
    )
  }

  return (
    <Feed className={classNames('myd-notifications-list', className)}>
      {
        _.map(notifications, notification => {
          const momentDate = moment(notification.date)
          const date = momentDate.format("dddd, MMMM Do YYYY, h:mm:ss a")
          const notificationReaded = notification.notificationStatus.isRead === true ? 'myd-notification-read' : ''
          let externalSite = false
          let hasLink = true

          switch(notification.content.type){
            case('NEW_MESSAGE_WIDGET'):
            case('DELETED_MESSAGE_WIDGET'):
            case('NEW_PRIVATE_MESSAGE_WIDGET'):
            case('NEW_MESSAGE_COLLECTION'):
            case('WIDGET_LIKED'):
            case('DELETED_MESSAGE_COLLECTION'):
              externalSite = true
              break
            case('PLANNING_DELETED'):
              hasLink = false
              break
            default:
              break
          }

          return (
            <Feed.Event key={ notification.id } className={ notificationReaded }>
              <Feed.Label>
                <span className='myd_avatar small' style={{'backgroundImage': `url('${notification.user.avatar}')`}}></span>
              </Feed.Label>
              <Feed.Content>
                <Feed.Summary>
                  <Feed.User>{ notification.user.firstName } { notification.user.lastName }</Feed.User>
                  <Feed.Date>{ date }</Feed.Date>
                </Feed.Summary>
                {
                  notification.content.text &&
                  <Feed.Extra text>
                    { notification.content.text }
                  </Feed.Extra>
                }
                {
                  notification.contentTitle &&
                  <Feed.Extra text className='myd-content-title'>
                    { notification.contentTitle }
                  </Feed.Extra>
                }
                {
                  hasLink &&
                  <Feed.Meta>
                    {
                      externalSite ?
                      <a
                        href={mydWWWOauthUrl(`http://library.mydocumenta.com${notification.content.linkContent}`)}
                        onClick={ (e) => ! notification.notificationStatus.isRead && props.changeNotificationStatus(notification.id, 'read') }
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        { _t('WIDGET_GO_TO_CONTENT') }
                      </a>
                      :
                      <Link
                        to={ notification.content.linkContent }
                        onClick={ (e) => ! notification.notificationStatus.isRead && props.changeNotificationStatus(notification.id, 'read') }
                      >
                        { _t('WIDGET_GO_TO_CONTENT') }
                      </Link>
                    }
                  </Feed.Meta>
                }
              </Feed.Content>
              <Feed.Meta className='myd-mark-as-read'>
                {
                  notification.notificationStatus.isRead !== true ?
                  <Popup
                    trigger= {
                      <Icon
                        link
                        name='circle'
                        color='grey'
                        value={ notification.id }
                        onClick={ () =>  props.changeNotificationStatus(notification.id, 'read') }
                      />
                    }
                    position='top center'
                    content={ _t('MARK_AS_READ', true) }
                  />
                  :
                  null
                }
                <Feed.Meta className='myd-hide-not'>
                  <Popup
                    trigger= {
                      <Icon
                        link
                        name='close'
                        color='grey'
                        onClick={ (e) => props.changeNotificationStatus(notification.id, 'delete') }
                      />
                    }
                    position='bottom center'
                    content={ _t('HIDE_NOTIFICATION', true) }
                  />
                </Feed.Meta>
              </Feed.Meta>
            </Feed.Event>
          )
        })
      }
    </Feed>
  )
}


export const ListNotifications = connect(
  store => ({
  }),
  dispatch => ({
    changeNotificationStatus: bindActionCreators(changeNotificationStatus, dispatch),
  }),
)(_ListNotifications)


const MydNotifications = props => {
  let { notifications, loading } = props

  return (
    <div className='myd-notifications'>
      <Segment>
        <Header as='h3' color='red'>
          { _t('NOTIFICATIONS_TITLE') }{' '}
          <Loader inline size='mini' active={loading} />
        </Header>
      </Segment>
      <ListNotifications notifications={notifications} loading={loading} />
    </div>
  )
}

export default MydNotifications
